// extracted by mini-css-extract-plugin
module.exports = {"top-player-sidebar":"top-player-sidebar","stats-container":"stats-container","title":"title","stats-player-list":"stats-player-list"};